import { EyeFilled, CloudDownloadOutlined, CopyFilled, TruckOutlined } from '@ant-design/icons'
import TableBase from 'components/Table/TableBase'
import styled from 'styled-components'
import { numberWithCommas } from 'utils'
import { Link, useHistory } from 'react-router-dom'
import { Button } from 'antd'
import ReOrder from './ReOrder'
import { openInNewTab } from 'helpers'

const OptionAction = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;

  svg {
    cursor: pointer;
  }
`

const HistoryTable = ({
  dataList,
  setParams,
  loadingList,
  setListSelectedOrder,
  searchOrder,
}: {
  dataList: any
  setParams: (input: any) => void
  loadingList: boolean
  setListSelectedOrder: (input: any) => void
  searchOrder: () => void
}) => {
  const history = useHistory()

  const columns = [
    {
      title: 'Mã đơn',
      dataIndex: 'order_code',
      render: (value) => value,
    },
    {
      title: 'Người nhận',
      dataIndex: '',
      render: (_, record) => (
        <div style={{ textAlign: 'left' }}>
          <p>{record?.receiver?.full_name}</p>
          <p>{record?.receiver?.phone_number}</p>
        </div>
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: '',
      render: (record) => (
        <div style={{ textAlign: 'center' }}>
          <p>{record?.status_string}</p>
          {record?.is_fail ? <p style={{ color: 'red' }}>{record?.note}</p> : ''}
        </div>
      ),
    },
    {
      title: 'Thu hộ',
      dataIndex: 'cod',
      render: (cod) => (cod ? `${numberWithCommas(cod)}đ` : 0),
    },
    {
      title: 'Thời gian',
      dataIndex: 'updated_at',
      width: 260,
      render: (_, record) => (
        <div>
          <p>Ngày tạo: {record?.created_at}</p>
          <b>Cập nhật: {record?.updated_at}</b>
        </div>
      ),
    },
    {
      title: 'Thao tác',
      dataIndex: '',
      width: 210,
      render: (_, record) => (
        <OptionAction>
          {record?.is_fail ? (
            ''
          ) : (
            <Button onClick={() => openInNewTab(`/in-don-hang?id=${record?.id}`)} icon={<CloudDownloadOutlined />}>
              In đơn
            </Button>
          )}
          <Link to={`/tao-don-hang/${record?.id}`}>
            <Button icon={<CopyFilled />} title='Dùng lại thông tin'>
              Dùng lại thông tin
            </Button>
          </Link>
          <a href={`https://spx.vn/track?${record?.service_code}`} target={'_blank'} rel='noreferrer'>
            <Button icon={<TruckOutlined />} title='Xem lộ trình'>
              Lộ trình
            </Button>
          </a>
          <Button
            onClick={() => {
              history.push(`/xem-don-hang/${record?.id}`)
            }}
            icon={<EyeFilled />}
          >
            Xem
          </Button>
        </OptionAction>
      ),
    },
  ]

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setListSelectedOrder(selectedRows)
    },
  }

  const returnHtml = () => {
    return (
      <TableBase
        columns={columns}
        dataSource={dataList?.data?.orders}
        scroll={{ x: 1000 }}
        rowKey={(row) => row.id}
        pagination={{
          current: dataList?.data?.meta?.current_page,
          pageSize: dataList?.data?.meta?.per_page,
          total: dataList?.data?.meta?.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            if (pageSize !== dataList?.data?.meta?.per_page) {
              page = 1
            }
            window.scrollTo({ top: 0, behavior: 'smooth' })
            setParams((prev) => ({
              ...prev,
              page: page,
              per_page: pageSize,
            }))
          },
          showTotal: (total) => `Tổng ${total}`,
        }}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
      />
    )
  }

  return dataList?.data?.orders ? returnHtml() : <div style={{ textAlign: 'center' }}>Đang truy vấn...</div>
}

export default HistoryTable
